import { render } from "./CreateSummary.vue?vue&type=template&id=3453630d"
import script from "./CreateSummary.vue?vue&type=script&lang=js"
export * from "./CreateSummary.vue?vue&type=script&lang=js"

import "./CreateSummary.vue?vue&type=style&index=0&id=3453630d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__